import classnames from 'classnames/bind';
import Link from 'next/link';
import styles from './index.module.scss';

import Text from '@components/common/text';
import Colors from '@domain/constant/colors';
import { FontStyle } from '@domain/constant/fontStyle';
import { useAccResults } from '@repository/acc';
import { RouteUrl } from '@utils/routeUtil';

import { AccResultRecordDto } from '@domain/rs/acca/test/AccResultRecordRs';
import DateFormat from '@utils/date/format';
import { FC, useEffect } from 'react';
import { useInterview } from '../../../context/interviewContext';
const cx = classnames.bind(styles);

interface ItemProps {
  data: AccResultRecordDto;
  isSelected: boolean;
  onClick: () => void;
  selectedLen: number;
}
const ResultItem: FC<ItemProps> = ({ data, isSelected, onClick, selectedLen }) => {
  return (
    <button className={cx('resultItem', { isSelected })} onClick={onClick}>
      <img src={data.thumbnailUrl} alt={data.name} width={48} height={48} style={{ objectFit: 'cover' }} />
      <div className={cx('textArea')}>
        <Text
          fontStyle={FontStyle.B2_B}
          ellipsis
          styles={{ width: 120 }}
          color={isSelected ? Colors.C_JOBDA_BLACK : Colors.C_COOL_GRAY_70}
        >
          {data.name}
        </Text>
        <Text fontStyle={FontStyle.B4_M} color={Colors.C_COOL_GRAY_60} styles={{ marginTop: 8 }}>
          {DateFormat.format(new Date(data.applicationDate), 'yyyy.MM.dd HH:mm')}
        </Text>
      </div>
      {!!selectedLen && (
        <div className={cx('selectArea')}>
          <Text fontStyle={FontStyle.B4_M} color={Colors.C_GREEN_200}>
            {selectedLen}
          </Text>
        </div>
      )}
    </button>
  );
};

interface Props {
  selectedCode: string | null;
  setSelectedCode: (code: string | null) => void;
}
const SideBar: FC<Props> = ({ selectedCode, setSelectedCode }) => {
  const { data, isLoading } = useAccResults();
  const isEmpty = !data?.resultRecords?.length;
  const { selectedAccQuestion } = useInterview();
  const selectedLen = (code: string) => selectedAccQuestion?.find((v) => v.accCode === code)?.questionSn.length ?? 0;

  const resultEls = data?.resultRecords?.map((result) => (
    <ResultItem
      key={result.code}
      data={result}
      isSelected={selectedCode === result.code}
      onClick={() => setSelectedCode(result.code)}
      selectedLen={selectedLen(result.code)}
    />
  ));

  useEffect(() => {
    if (!data) return;
    if (!selectedCode) {
      setSelectedCode(data.resultRecords[0]?.code);
    }
  }, [data]);

  if (isLoading) return null;

  return (
    <div className={cx('sideBarList')}>
      <div className={cx('intro')}>
        <div className={cx('introTitle')}>역량검사 결과표 선택</div>
        {!isEmpty && (
          <Link href={RouteUrl.ACCA_RESULTS} legacyBehavior>
            <a className={cx('btnViewAll')} role="button" target="_blank">
              전체 보기
            </a>
          </Link>
        )}
      </div>

      {/* [D] 역량검사 결과 리스트 */}
      <div className={cx('resultArea')}>
        {isEmpty && (
          <div className={cx('emptyArea')}>
            <div className={cx('emptyIcon')} />
            <Text fontStyle={FontStyle.B1_B}>역량검사 결과가 없어요</Text>
          </div>
        )}
        {resultEls}
      </div>
    </div>
  );
};

export default SideBar;
